export type AppLanguage = 'ru' | 'en';

export const DEFAULT_LANGUAGE: AppLanguage = 'ru';
export const LANGUAGE_STORAGE_KEY = 'lovo.interface-language';

export function isAppLanguage(value: unknown): value is AppLanguage {
  return value === 'ru' || value === 'en';
}

export function readStoredLanguage(): AppLanguage {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  try {
    const value = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isAppLanguage(value) ? value : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

export function storeLanguage(language: AppLanguage) {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Language switching must remain available when storage is blocked.
  }
}
